export default "__VITE_ASSET__dmI4m604__"